module.exports = __webpack_public_path__ + "static/media/set-storage-t3.fe817e79.nom";